import * as React from "react";
import { useState } from "react";
import { PopoverPosition } from "@mui/material";
import { MediaParticipant } from "@dvrt/web-phone-client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Root, Icon, ParticipantAvatar as AvatarBox, AvatarSpeaking, Text, TextSubtitle, Hand } from "./styles";
import { useParticipantDisplayName } from "../../../hooks";
import { useSelector } from "react-redux";
import { State } from "conference/types";
import { useParticipantStatus } from "../../../participantStatus";
import ParticipantMenu from "../../../participant-menu/Container";
import { getNameLetters } from "conference/components/meeting-page/room/tools";
import { FormattedMessage } from "react-intl";

type Props = {
    data: MediaParticipant;
};

const ParticipantItem = ({ data }: Props) => {
    const displayName = useParticipantDisplayName(data);
    const speakers = useSelector((state: State) => state.room.speakerList);
    const [menuPos, setMenuPos] = useState<PopoverPosition>();
    const status = useParticipantStatus(data.cname);
    const isMuted = status.isMuted;
    const speaking = speakers.includes(data.cname) && !isMuted;

    return (
        <React.Fragment>
            <Root
                onClick={(ev) => {
                    setMenuPos({
                        left: ev.clientX,
                        top: ev.clientY + 15,
                    });
                }}
            >
                <Icon sx={{ marginRight: "0.5em", minWidth: 18 }}>
                    <FontAwesomeIcon fixedWidth icon={isMuted ? "microphone-slash" : "microphone"} />
                </Icon>
                {speaking ? (
                    <AvatarSpeaking>{getNameLetters(displayName)}</AvatarSpeaking>
                ) : (
                    <AvatarBox>{getNameLetters(displayName)}</AvatarBox>
                )}
                <Text>
                    {displayName}
                    {status.isHost && (
                        <TextSubtitle>
                            <FormattedMessage id="meetingPage.room.sidebar.participants.host" defaultMessage="host" />
                        </TextSubtitle>
                    )}
                </Text>
                {data.screen ? (
                    <Icon>
                        <FontAwesomeIcon icon="desktop" />
                    </Icon>
                ) : (
                    <Hand sx={{ opacity: status.handRaised ? 1 : 0.1 }}>
                        <FontAwesomeIcon icon="hand-paper" />
                    </Hand>
                )}
            </Root>
            <ParticipantMenu participant={data} position={menuPos} onClose={() => setMenuPos(null)} />
        </React.Fragment>
    );
};

export default ParticipantItem;
